const validateCSV = (data, contractType, setBatchError) => {
    let errorData = [];
    data.forEach((item, index) => {
        const itemsErrors = [];
        if (!item.no) {
            itemsErrors.push({
                row: index,
                message: `Required field 'No' is empty`,
            });
        }
        if (!item["Token Name"]) {
            itemsErrors.push({
                row: index,
                message: `Required field 'Token Name' is empty`,
            });
        }
        if (item["Contract"] && item["Contract"] !== contractType) {
            itemsErrors.push({
                row: index,
                message: `Type of contract invalid`,
            });
        }
        if (
            item["Link to content"] &&
            !/^https?:\/\//.test(item["Link to content"])
        ) {
            itemsErrors.push({
                row: index,
                message: `Link may be beginning from 'http://' or 'https://'`,
            });
        }
        if (item["Amount"] && item["Amount"] > 1) {
            if (contractType === "ERC721") {
                itemsErrors.push({
                    row: index,
                    message: `Сount in ERC721 token can not be more 1`,
                });
            }
        } else if (item["Amount"] && item["Amount"] <= 0) {
            itemsErrors.push({
                row: index,
                message: `Token count must be more 0`,
            });
        }
        if (item["Price"] && item["Price"] <= 0) {
            itemsErrors.push({
                row: index,
                message: `Token price must be positive`,
            });
        }
        if (item["Royalties"] && item["Royalties"] < 0) {
            itemsErrors.push({
                row: index,
                message: `Token Royalties must be positive`,
            });
        }
        if (!item["Royalty Wallet"]) {
            itemsErrors.push({
                row: index,
                message: `Royalty Wallet is empty. Need 'Self' or address`,
            });
        }
        if (
            item["Lockable content"] !== "yes" &&
            item["Lockable content"] !== "no"
        ) {
            itemsErrors.push({
                row: index,
                message: `Lockable content must be'yes' or 'no' only`,
            });
        }
        if (item["Lockable content"] === "yes" && !item["Lockable link"]) {
            itemsErrors.push({
                row: index,
                message: `Lockable content is 'yes', but Lockable link is empty`,
            });
        }
        if (itemsErrors.length > 0) {
            errorData.push(itemsErrors);
        }
    });
    if (errorData) {
        setBatchError(errorData);
    }
};
export { validateCSV };
